import { render, staticRenderFns } from "./BRadioGroup.vue?vue&type=template&id=055d0541&scoped=true"
import script from "./BRadioGroup.vue?vue&type=script&lang=ts"
export * from "./BRadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./BRadioGroup.vue?vue&type=style&index=0&id=055d0541&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d0541",
  null
  
)

export default component.exports